<template>
    <w-flex wrap class="grow justify-space-between basis-zero mb3">
        <div class="xs6 pa3" v-for="(graph, idx) in graphs" :key="idx" >
            <div class="py3">
                <w-card bg-color="deep-purple-light2" shadow>
                    <w-flex wrap>
                        <div class="xs6 pa3">
                            <div class="py3">
                                <h2 class="dashboard-title " style="color:black">{{graph.title}}</h2>
                                <div v-if="loading" >
                                    <h2 class="dashboard-title" style="color:black">RM 0</h2>
                                    <h2 class="dashboard-title" style="color:black">0 %</h2>
                                </div>
                                <div v-else>
                                    <h2 class="dashboard-title" style="color:black">RM {{moneyFormat(graph.difference.amount)}}</h2>
                                    <h2 class="dashboard-title" style="color:black" v-if="graph.difference.percentage > 0">{{Math.abs(graph.difference.percentage)}}% <w-icon>fal fa-arrow-up</w-icon></h2>
                                    <h2 class="dashboard-title" style="color:black" v-else-if="graph.difference.percentage < 0">{{Math.abs(graph.difference.percentage)}}% <w-icon>fal fa-arrow-down</w-icon></h2>
                                    <h2 class="dashboard-title" style="color:black" v-else-if="graph.difference.percentage == 0">{{Math.abs(graph.difference.percentage)}}% <w-icon>fal fa-minus</w-icon></h2>
                                </div>
                            </div>
                        </div>
                        <div class="xs6 pa3">
                            <div v-if="loading" class="d-flex justify-center align-center">
                                <w-spinner fade color="white"/>
                            </div>
                            <chartBarNaked :graph="graph" v-else="loading" />
                        </div>
                    </w-flex>
                </w-card>
            </div>
        </div>
    </w-flex>
</template>

<script>
    import axios from "axios";
    import chartBarNaked from "@/Components/charts/chart-bar-naked.vue"
    import { moneyFormat } from "../../Cukai/CukaiTanah/helper";

    export default {
        name: "GraphBarKutipan",
        components: {
            chartBarNaked
        },
        props: {

        },

        data: ()=>{
            return {
                apiBaseUrl: process.env.MIX_API_BASE_URL,
                loading: false,
                render: false,
                graphs: [
                    {
                        title: "Kutipan Terkumpul",
                        difference:{
                            amount:0,
                            percentage:0
                        },
                        labels:[],
                        data : [],
                    },
                    {
                        title: "Kutipan Bulanan",
                        difference:{
                            amount:0,
                            percentage:0
                        },
                        labels:[],
                        data : [],
                    },
                    {
                        title: "Kutipan Harian",
                        difference:{
                            amount:0,
                            percentage:0
                        },
                        labels:[],
                        data : [],
                    }
                ]
            }
        },
        mounted() {
            // this.getAPI();
        },
        methods: {
            async getAPI() {
                this.loading = true
                await axios.get(`${this.apiBaseUrl}/dashboard/kutipan-tahunan`)
                .then(resp=>{
                    const { barChartTahun, barChartBulan, barChartHari } = resp.data;

                    this.graphs[0] = barChartConfig(barChartTahun,this.graphs[0]);
                    this.graphs[1] = barChartConfig(barChartBulan,this.graphs[1]);
                    this.graphs[2] = barChartConfig(barChartHari,this.graphs[2]);
                })
                .catch(err=>{
                    console.error(err)
                })

                function barChartConfig(barChartdata, ori){
                    const {labels,data} = barChartdata;
                    const amount = data[1].toFixed(2);
                    const diff = (data[1] - data[0])
                    const base = diff > 0 ? data[1] : data[0];
                    const percentage = (diff/base * 100).toFixed(2);
                    return {...ori, labels  , data, difference: {amount, percentage}}
                }

                this.forceRerender()
                this.loading = false
            },
            async forceRerender(){
                this.render = false;
                await this.$nextTick();
                this.render = true;
            },
            moneyFormat
        }

    };
</script>
